export const NUVEM_PAGO_ONBOARDING_TASK = 'setup_payments';

export const FREEMIUM_COMMERCIAL_NAME = 'começo';

export const NUVEM_PAGO_ONBOARDING_ROUTES = {
  settings: '/settings/payments/nuvempago',
  admin: '/admin/nuvempago/settings',
  pagoNube: '/nuvempago/#/config',
  onboarding: '/nuvemPago/#/onboarding',
  pagoNubeOnboarding: '/pago-nube-onboarding',
} as const;

// Specific URLs for the isolated component
export const NUVEM_PAGO_ONBOARDING_ISOLATED_ROUTES = {
  review: '/admin/v2/nuvempago/settings',
  viewOtherMethods: 'settings/payments',
  dashboard: '/admin/v2/nuvempago/dashboard',
} as const;

export const NUVEM_PAGO_AB_TEST_ROUTES = {
  settings: '/nuvempago#/settings',
  dashboard: '/nuvempago#/dashboard',
} as const;

export const BR_ONBOARDING_VARIANTS = [
  'br-onboarding-variant-0',
  'br-onboarding-variant-1',
  'br-onboarding-variant-2',
];
